<template>
  <div class="medcard-feature d-flex align-start flex-column flex-md-row">
    <div class="mr-md-12 mb-6 mb-md-0 medcard-feature__header">
      <div class="text-h5 text-md-h4">
        Электронная медкарта — больше никаких папок с бумагами
      </div>
      <div class="mt-4 text-body-1 text-sm-landing-h6">
        МедТочка надёжно сохранит ваши документы и обеспечит безопасность медицинских данных с помощью
        <span class="font-weight-bold">шифрования.</span>
      </div>
    </div>

    <div class="gr-4 gr-sm-6 d-flex flex-column">
      <v-sheet
        v-for="(item, index) in medcardFeatures"
        :key="item.title"
        class="pt-7 medcard-feature__item d-flex flex-column justify-space-between rounded-xl overflow-hidden"
        elevation="0"
        :color="item.isFamilyCalendar ? 'ui-kit-bg-special' : 'ui-kit-bg-secondary'"
      >
        <div class="d-flex px-6 mb-4 mb-md-0">
          <span
            v-if="!item.isFamilyCalendar"
            class="list-number-marker text-primary mr-6"
          >{{ index + 1 }}</span>
          <div class="mt-md-3 font-weight-semi-bold text-landing-h6 text-sm-landing-h5">
            {{ item.title }}
          </div>
        </div>

        <LandingFeatureImage
          width="100%"
          sm-width="304"
          :class="item.isFamilyCalendar ? 'align-self-end' : 'align-self-center'"
          :src="item.img.src"
          :alt="item.img.alt"
          :sm-src-set="item.img.smSrc"
        />
      </v-sheet>

      <LandingFeatureBtn
        width="100%"
        variant="tonal"
        text="Завести медкарту"
        target="_blank"
        :href="`${useRuntimeConfig().public.mtUrl}/medcard`"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
const medcardFeatures = computed(() => [
  {
    title: 'Загружайте заключения, анализы и обследования и заполняйте анкету пациента',
    img: {
      src: '/images/features/patient/upload_documents_and_questionnaire.png',
      smSrc: '/images/features/patient/upload_documents_and_questionnaire_mobile_3x.png 3x',
      alt: 'Просмотр документов в медкарте',
    },
  },
  {
    title: 'Сканируйте QR-код и открывайте защищённый доступ к медкарте любому врачу',
    img: {
      src: '/images/features/patient/scan_qr_and_share_your_medcard.png',
      smSrc: '/images/features/patient/scan_qr_and_share_your_medcard_mobile.png 1x, /images/features/patient/scan_qr_and_share_your_medcard_mobile_3x.png 3x',
      alt: 'Доступ к медкарте по QR-коду или ссылке',
    },
  },
  {
    title: 'Получайте документы от врачей и клиник прямо в медкарту',
    img: {
      src: '/images/features/patient/get_documents_in_medcard.png',
      smSrc: '/images/features/patient/get_documents_in_medcard_mobile.png 1x, /images/features/patient/get_documents_in_medcard_mobile_3x.png 3x',
      alt: 'Пуш о новом документе в медкарте',
    },
  },
  {
    title: 'Заведите женский календарь и отмечайте дни менструации и симптомы, делитесь данными с вашим врачом',
    isFamilyCalendar: true,
    img: {
      src: '/images/features/patient/female_calendar.png',
      smSrc: '/images/features/patient/female_calendar_mobile.png 1x, /images/features/patient/female_calendar_mobile_3x.png 3x',
      alt: 'Женский календарь в медкарте',
    },
  },
])
</script>

<style lang="scss">
@use '@/assets/vuetify/settings';
@use 'sass:map';

.medcard-feature {
  &__header {
    @media #{map.get(settings.$display-breakpoints, 'md-and-up')} {
      position: sticky;
      top: 120px;
    }
  }

  &__item {
    @media #{map.get(settings.$display-breakpoints, 'md-and-up')} {
      width: 624px;
    }
  }
}
</style>
